// @flow
import { MediaSurveysActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    mediaSurvey: {},
    listaMediaSurveys: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type MediaSurveysAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { mediaSurvey?: {} | null, listaMediaSurveys?: [] | null, loading?: boolean, +value ?: boolean };

const MediaSurveys = (state: State = INIT_STATE, action: MediaSurveysAction): any => {
    // console.log(action);
    switch (action.type) {
        case MediaSurveysActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case MediaSurveysActionTypes.GET_MEDIA_SURVEY: {
                    return {
                        ...state,
                        mediaSurvey: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case MediaSurveysActionTypes.LIST_MEDIA_SURVEYS: {
                    return {
                        ...state,
                        listaMediaSurveys: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case MediaSurveysActionTypes.ADD_MEDIA_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case MediaSurveysActionTypes.UPDATE_MEDIA_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case MediaSurveysActionTypes.DELETE_MEDIA_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case MediaSurveysActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case MediaSurveysActionTypes.GET_MEDIA_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        mediaSurvey: {},
                        loading: false,
                    };
                }
                case MediaSurveysActionTypes.LIST_MEDIA_SURVEYS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaMediaSurveys: [],
                        loading: false,
                    };
                }
                case MediaSurveysActionTypes.ADD_MEDIA_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case MediaSurveysActionTypes.UPDATE_MEDIA_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case MediaSurveysActionTypes.DELETE_MEDIA_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case MediaSurveysActionTypes.GET_MEDIA_SURVEY:
            return { ...state, error: false, loading: true };
        case MediaSurveysActionTypes.LIST_MEDIA_SURVEYS:
            return { ...state, error: false, loading: true };
        case MediaSurveysActionTypes.ADD_MEDIA_SURVEY:
            return { ...state, error: false, loadingForm: true };
        case MediaSurveysActionTypes.UPDATE_MEDIA_SURVEY:
            return { ...state, error: false, loadingForm: true };
        case MediaSurveysActionTypes.DELETE_MEDIA_SURVEY:
            return { ...state, error: false, loading: true };
        case MediaSurveysActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                mediaSurvey: {},
                listaMediaSurveys: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default MediaSurveys;
